import React, {createRef, useState, useRef} from 'react';
import moment from "moment";
import axios from "axios";
import __ from "lodash";
import MultipleDatesPicker from './MultipleDatePicker';
import {
  Checkbox,
  FormControlLabel,
  Typography,
  Grid,
  Paper,
  FormHelperText,
  Button, Select, MenuItem, InputLabel
} from "@material-ui/core";

import AddPermitValidator from "../validators/AddPermitValidator";
import {DatePicker, FlightNumber, MaskedTime, SwitchValue} from "../../../controls";
import PermitFormDialog from "../../../controls/FormDialog";
import CountryLookup from "../../Settings/components/CountryLookup";
import AirportLookup from "../../Airports/components/AirportsLookup";
import AircraftListLookup from "../../Aircraft/components/AircraftListLookup";
import MaskedText from "../../../controls/MaskedText";


const today = moment().toISOString();

export default (SystemData, apiSitePrefix, queryClient, extraKeys, handleAddPermit, formatChars) => {
  const requestRef = createRef(0);

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    newPermitMode: false,
    fixedDates: true,
    openDatesSelector: false,
  });

  const [editRow, setEditRow] = useState({});

  const minDate = moment.utc().startOf('month').subtract(1, 'month');
  const initialDate = minDate.toISOString();
  const dateFormat = "DD/MM/YYYY";

  const buttons = {
    save:{icon: "check_circle", label: "Generate", color: "primary", disabled: (status)=>{return status.error}},
    cancel:{icon: "cancel", label: "Cancel", color: "primary"}
  };
  const permitTypes = [{"code":"OVERFLIGHT","value":"Overflight"},{"code":"LANDING","value":"Landing"},{"code":"DEPARTURE","value":"Departure"}];
  const arrangedByValues = [{"code":"CHARTER","value":"Magma Aviation"},{"code":"OPERATOR","value":"Aircraft Operator"},{"code":"PARTNER","value":"Agent"}];

  const handleClose = () => {
    const closedState = {
      showDialog: false,
      newPermitMode: false,
      fixedDates: true,
      openDatesSelector: false,
    }
    setDialogStates({...dialogStates, ...closedState});
    setEditRow(null);
  }

  const actionPermit = (rowData) => {
    let newPermitMode = false;
    if ( rowData &&  ! __.has(rowData, ["DOW"]) ) {
      rowData = {
        permitType: "",
        countryCode: "",
        airportCode: "",
        arrivalAirlineCode: null,
        arrivalFlightNo: null,
        scheduleTime: "00:00",
        departureAirlineCode: null,
        departureFlightNo: null,
        tailNumbers: "",
        validFrom: moment().startOf("month").isAfter(moment()) ? moment().startOf("month").format('YYYY-MM-DD') : moment().format("YYYY-MM-DD"),
        period: moment().format("YYYYMM"),
        validTo: moment().endOf("month").format("YYYY-MM-DD"),
        permitDates: "",
        DOW: "",
        newPermitMode: true,
        route: "",
        fixedDates: true
      };
      newPermitMode = true;
    } else {
      let permitType = __.find(permitTypes, {code: rowData.permitType});
      if (!permitType) {
        permitType = __.find(permitTypes, {value: rowData.permitType});
      }
      rowData.permitType = permitType ? permitType.value : "";
      const permitHours = rowData.permitHours.split(",");
      rowData["scheduledTime"] = permitHours[0].trim() + ":00";
      rowData["fixedDates"] = true;
    }
    const days = [1,2,3,4,5,6,7];
    const requiredDays = [];
    days.map(day => {
      requiredDays.push({day: day, checked: rowData.DOW === day});
    });

    const permitDates = getPermitDates(rowData.period, rowData.permitDates);
    let minRequiredDate;
    let maxRequiredDate;
    if ( permitDates && Array.isArray(permitDates) && permitDates.length > 0) {
      minRequiredDate = moment(permitDates[0], dateFormat);
      maxRequiredDate = moment(permitDates[permitDates.length - 1], dateFormat);
    }

    setEditRow({...rowData, requiredDays, minRequiredDate: minRequiredDate, maxRequiredDate: maxRequiredDate});
    setDialogStates({...dialogStates, showDialog:true, newPermitMode});
  }

  const userSelectedDates = () => {
    if (editRow.userSelectedDates) {
      return editRow.userSelectedDates;
    }

    const dates = [];
    if (editRow && editRow.permitDates)
      editRow.permitDates.split(",").map(day => {
        const date = moment(editRow.period + day, "YYYYMMDD").toDate();
        dates.push(date);
      })

    return dates;
  }

  const getPermitDates = (period, days) => {
    const permitDates = [];
    const requiredDates = days.split(",");
    requiredDates.map(date => {
      const displayDate = moment(`${period}${date}`, "YYYYMMDD").format(dateFormat);
      permitDates.push(displayDate);
    })
    return permitDates;
  }

  const requiredPermitDates = () => {
    if (editRow.userSelectedDates) {
      return editRow.userSelectedDates.map(date => {
        return moment(date).format(dateFormat);
      })
    }

    return getPermitDates(editRow.period, editRow.permitDates);
  }

  const generateNewPermit = async (rowData, record) => {
    SystemData.toggleLoadingProgress(true);
    const serverDateFormat = "YYYY-MM-DD";

    if (dialogStates.newPermitMode) {
      const permitType = __.find(permitTypes, {value: record.permitType});
      editRow.permitType = permitType.code;

      const arrangedBy = __.find(arrangedByValues, {value: record.arrangedBy});
      editRow.arrangedBy = arrangedBy.code;
    }

    let days = "1234567";
    rowData.requiredDays.map(day => {
      if (!day.checked)
        days = days.replace(day.day, ".");
    })

    let permitDates = [];
    if (rowData.userSelectedDates) {
      rowData.userSelectedDates.map(date => {
        permitDates.push(moment(date).format(serverDateFormat));
      })
    } else {
      editRow.permitDates.replace(" ", "");
      const requiredDates = editRow.permitDates.split(",");
      requiredDates.forEach(date => {
        permitDates.push(moment(`${editRow.period}${date}`, "YYYYMMDD").format(serverDateFormat));
      })
    }

    const validFrom = dialogStates.fixedDates && rowData.minRequiredDate ? rowData.minRequiredDate : editRow.validFrom ? editRow.validFrom : moment(record.period, "YYYYMM").startOf("month").isAfter(moment())?moment(record.period, "YYYYMM").startOf("month").format('YYYY-MM-DD'):moment().format("YYYY-MM-DD");
    const validTo = dialogStates.fixedDates && rowData.maxRequiredDate ? rowData.maxRequiredDate : editRow.validTo ? editRow.validTo : moment(record.period, "YYYYMM").endOf("month");

    const tailNumbers = rowData.tailNumbers ? rowData.tailNumbers : record.tailNumbers;

    const newPermit = {}; //__.omit(record, ["tableData", "permitDates", "requiredDays"]);
    if (dialogStates.newPermitMode)
      newPermit["arrangedBy"] = editRow.arrangedBy;
    newPermit["permitType"] = rowData.permitType;
    newPermit["countryCode"] = rowData.countryCode;
    newPermit["airportCode"] = rowData.airportCode;
    if (rowData.arrivalAirlineCode)
      newPermit["arrivalAirlineCode"] = rowData.arrivalAirlineCode;
    if (rowData.arrivalFlightNo)
      newPermit["arrivalFlightNo"] = rowData.arrivalFlightNo;
    if (rowData.departureAirlineCode)
      newPermit["departureAirlineCode"] = rowData.departureAirlineCode;
    if (rowData.departureFlightNo)
      newPermit["departureFlightNo"] = rowData.departureFlightNo;
    newPermit["departureTime"] = record.scheduledTime;
    newPermit["usePermitFlightDates"] = dialogStates.fixedDates;
    newPermit["days"] = days;
    newPermit["tailNumbers"] = tailNumbers;
    newPermit["validFrom"] = moment(validFrom).format(serverDateFormat);
    newPermit["validTo"] = moment(validTo).format(serverDateFormat);
    newPermit["permitDates"] = permitDates;
    newPermit["route"] = record.route;
    newPermit["status"] = "REQUESTED";
    newPermit["notes"] = "";

    let response = null;
    try {
      response = await axios.post(`${apiSitePrefix}/permits/generatedPermit`, newPermit);
    } catch (err) {
      SystemData.openAlert(
        "Error",
        `An unexpected error has occurred creating the permit.`
      );
      console.debug(err);
    }
    if (!response) {
      SystemData.openAlert(
        "Error",
        `An unexpected error has occurred creating the permit.`
      );
    } else if (response.error) {
      SystemData.openAlert(
        "Error",
        `Error: ${response.error.errorMessage}`
      );
    } else {
      if (dialogStates.newPermitMode)
        queryClient.invalidateQueries(["Permits"]);
      else
        queryClient.invalidateQueries(["VRequiredPermits"]);
      handleClose();
    }
    SystemData.toggleLoadingProgress(false);
  }

  const dialogBox = (
    <>
      {dialogStates.showDialog
        ?
        <PermitFormDialog
          title={`Generate ${editRow ? editRow.permitType : ""} Permit`}
          message=""
          buttons={buttons}
          open={dialogStates.showDialog}
          record={editRow}
          dialogOptions={{maxWidth: "md", fullWidth: true}}
          validator={AddPermitValidator}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const record = state.record;
              generateNewPermit(editRow, record);
            } else {
              handleClose();
            }
          }}
        >
          <Grid container checkchildren="true" spacing={3}>
            {(record) =>  (
              dialogStates.newPermitMode
                ?
                <Grid container checkchildren="true" spacing={3} style={{marginLeft: 2}}>
                  <Grid item xs={6} checkchildren="true">
                    <InputLabel shrink id="permit-select-label">Permit Type</InputLabel>
                    <Select
                      id="permitType"
                      label="Permit Type"
                      onChange={
                        (value, data) => {
                          data.recordChange({permitType: value})
                        }
                      }
                      renderValue={(value) => (`${value}`)}
                    >
                      {(permitTypes) ?
                        permitTypes.map((permitType) => {
                          return (
                            <MenuItem key={permitType.code} value={permitType.value}>{permitType.value}</MenuItem>);
                        }) :
                        null
                      }
                    </Select>
                  </Grid>
                  <Grid item xs={6} checkchildren="true" style={{marginLeft: -5, marginRight: 5}}>
                    <InputLabel shrink id="permit-select-label">To be Arranged By</InputLabel>
                    <Select
                      id="arrangedBy"
                      label="To Be Arranged By"
                      onChange={
                        (value, data) => {
                          data.recordChange({arrangedBy: value})
                        }
                      }
                      renderValue={(value) => (`${value}`)}
                    >
                      {(arrangedByValues) ?
                        arrangedByValues.map((arrangedBy) => {
                          return (
                            <MenuItem key={arrangedBy.code} value={arrangedBy.value}>{arrangedBy.value}</MenuItem>);
                        }) :
                        null
                      }
                    </Select>
                  </Grid>
                </Grid>
                :
                <></>
            )}
            <Grid item xs={6} checkChildren={true}>
              {(record) => (
                <MaskedText
                  id="route"
                  label="Route"
                  inputLabelProps={{ shrink: true }}
                  style={{width: "100%"}}
                  mask={"aaa-aaa-aaa"}
                  maskChar={""}
                  alwaysShowMask={false}
                  formatChars={{ a: "[a-zA-Z]" }}
                  forceUpperCase={true}
                  beforeChange={value => {
                    let trimmedRoute = `${value}`;
                    if (trimmedRoute.length > 0 && trimmedRoute.charAt(trimmedRoute.length -1) === "-")
                      trimmedRoute = trimmedRoute.substr(0, trimmedRoute.length -1);
                    //console.log(trimmedRoute);
                    return trimmedRoute;
                  }}
                />
              )}
            </Grid>
            {(record) => (
              <Grid item xs={3} checkchildren="true">
                {record.permitType.toUpperCase() === "OVERFLIGHT"
                  ?
                  <CountryLookup
                    id="countryCode"
                    label="Overflight Country"
                    inputLabelProps={{ shrink: true }}
                    style={{width: "100%"}}
                    value={record.countryCode}
                    returnType={"object"}
                    onChange={(returnObject, props) => {
                      if (returnObject.found) {
                        setEditRow({...editRow, countryCode: returnObject.data.countryCode, countryName: returnObject.data.countryName});
                      } else {
                        setEditRow({...editRow, countryCode: returnObject.value, countryName: ""});
                      }
                      props.onChange(returnObject.value);
                    }}
                  />
                  :
                  <AirportLookup
                    id="airportCode"
                    label={(record.permitType.toUpperCase() === "DEPARTURE" ? "Origin" : "Destination") + " Airport"}
                    inputLabelProps={{ shrink: true }}
                    style={{width: "100%"}}
                    value={record.airportCode}
                    returnType={"object"}
                    onChange={(returnObject, props) => {
                      if (returnObject.found) {
                        setEditRow({...editRow, airportCode: returnObject.data.airportCode, airportName: returnObject.data.airportName, countryCode: returnObject.data.countryCode });
                      } else {
                        setEditRow({...editRow, airportCode: returnObject.value, airportName: ""});
                      }
                      props.onChange(returnObject.value);
                    }}
                  />
                }
              </Grid>
            )}
            <Grid item xs={3} checkchildren="true">
              <Typography style={{ fontFamily: 'inherit', whiteSpace: 'pre-line', variant: "subtitle1", marginTop: 20 }}>
                {editRow.airportName  ? editRow.airportName : editRow.countryName ? editRow.countryName : ""}
              </Typography>
            </Grid>
            {record => {
              if (record.permitType !== "Overflight")
                return (
                  <Grid item xs={dialogStates.newPermitMode ? 4 : 6} checkchildren="true">
                    {record.permitType !== "Overflight"
                      ?
                        <FlightNumber
                          label="Inbound Flight"
                          mask={"XX-999aa"}
                          code={record.arrivalAirlineCode}
                          number={record.arrivalFlightNo}
                          //inputProps={defaultEditProps}
                          onChange={(e, props) => {
                            const flightNo = parseInt(e.number);
                            setEditRow({...editRow, arrivalAirlineCode: e.code, arrivalFlightNo: flightNo});
                          }}
                        />
                      :
                        null
                    }
                  </Grid>
                );
                return null;
              }
            }
            <Grid item xs={dialogStates.newPermitMode ? 4 : 6} checkchildren="true">
              {(record) => (
                <FlightNumber
                  label={`${record.permitType === "Overflight" ? "Flight" : "Outbound Flight"}`}
                  mask={"XX-999aa"}
                  code={record.departureAirlineCode}
                  number={record.departureFlightNo}
                  //inputProps={defaultEditProps}
                  onChange={(e, props) => {
                    const flightNo = parseInt(e.number);
                    setEditRow({...editRow, departureAirlineCode: e.code, departureFlightNo: flightNo});
                  }}
                />
              )}
            </Grid>
            {record=> {
              if (dialogStates.newPermitMode)
                return (
                  <Grid item xs={4} checkchildren="true">
                    <MaskedTime
                      label="Scheduled Departure Time (Origin)"
                      inputLabelProps={{shrink: true}}
                      onChange={(value, props) => {
                        props.recordChange({scheduledTime: value});
                      }}
                    />
                  </Grid>
                )
              else if (record.permitType === "Overflight")
                return (<Grid item xs={6} />)
            }}
            <Grid container xs={6}  checkchildren="true" spacing={3} style={{marginLeft: 3}}>
              <Grid item xs={7} checkChildren="true">
                <SwitchValue
                  id="fixedDates"
                  color={"primary"}
                  label={"Switch to fixed dates"}
                  onChange={(value, props) => {
                    props.record = {...props.record, fixedDates: true};
                    props.onChange(value);
                    console.log(editRow);
                    setDialogStates({...dialogStates, fixedDates: value});
                  }}
                />
              </Grid>
              <Grid item xs={5} checkChildren="true">
                {(record) => {
                  if (dialogStates.fixedDates) {
                    return (
                      <Button
                        color={"primary"}
                        onClick={() => setDialogStates({...dialogStates, openDatesSelector: true})}
                      >
                        Select Dates
                      </Button>
                    )
                  }
                }}
              </Grid>
              <Grid item xs={12} checkchildren="true">
                {(record) => {
                  if (dialogStates.fixedDates) {
                    const permitDates = requiredPermitDates();
                    return (
                      <Paper variant="outlined" style={{marginTop: -70}}>
                        <div style={{marginTop: -13, marginLeft: 5, width: 120 }}>
                          <Paper elevation={0}>
                            <FormHelperText component="legend" variant={"filled"}> Required Dates </FormHelperText>
                          </Paper>
                        </div>
                        {permitDates.map(date => (
                          <Button>{`${date}`}</Button>
                        ))}
                      </Paper>
                    )
                  }
                  else {
                    const days = [1,2,3,4,5,6,7];
                    return (
                      <Paper variant="outlined" style={{marginTop: -70}}>
                        <div style={{marginTop: -13, marginLeft: 5, width: 120 }}>
                          <Paper elevation={0}>
                            <FormHelperText component="legend" variant={"filled"}> Required Days </FormHelperText>
                          </Paper>
                        </div>
                        {days.map(day => (
                          <FormControlLabel
                            value={day}
                            style={{marginLeft: 8, marginRight: 8}}
                            // control={<Checkbox color="primary" checked={record.DOW === day}/>}
                            control={
                              <Checkbox
                                color="primary"
                                name={day}
                                checked={__.find(record.requiredDays, {day: day}).checked}
                                onChange={e => {
                                  __.find(record.requiredDays, {day: parseInt(e.target.name)}).checked = e.target.checked;
                                }}
                              />
                            }
                            label={day}
                            labelPlacement="top"
                          />
                        ))}
                      </Paper>
                    )
                  }
                }}
              </Grid>
            </Grid>

            <Grid item xs={6} checkchildren="true">
              {(record) => (
                <Paper variant="outlined" style={{marginLeft: 10}}>
                  <div style={{marginTop: -13, marginLeft: 5, width: 80 }}>
                    <Paper elevation={0}>
                      <FormHelperText component="legend" variant={"filled"}> Aircraft </FormHelperText>
                    </Paper>
                  </div>
                  <AircraftListLookup
                    canEdit={true}
                    tailList={record.tailNumbers}
                    onChange={newTailList => {
                      record = {...record, tailNumbers: newTailList};
                      setEditRow({...editRow,tailNumbers: newTailList});
                    }}
                    width={400}
                  />
                </Paper>
              )}
            </Grid>
            <Grid item xs={6} checkchildren="true">
              {(record) => (
                <DatePicker
                  id="validFrom"
                  label="Required From Date"
                  initialValue={dialogStates.fixedDates ? editRow.minRequiredDate : moment(record.period, "YYYYMM").startOf("month").isAfter(moment())?moment(record.period, "YYYYMM").startOf("month").format('YYYY-MM-DD'):moment().format("YYYY-MM-DD")}
                  disableToolbar={true}
                  autoOk={true}
                  format={dateFormat}
                  onChange={(value, props) => {
                    setEditRow({...editRow, minRequiredDate: value, validFrom: value});
                    props.onChange(value);
                  }}
                />
              )}
            </Grid>
            <Grid item xs={6} checkchildren="true">
              {(record) => (
                <DatePicker
                  id="validTo"
                  label="Required To Date"
                  value={record.period}
                  initialValue={dialogStates.fixedDates ? editRow.maxRequiredDate : moment(record.period, "YYYYMM").endOf("month")}
                  disableToolbar={true}
                  autoOk={true}
                  format={dateFormat}
                  onChange={(value, props) => {
                    setEditRow({...editRow, maxRequiredDate: value, validTo: value});
                    props.onChange(value);
                  }}
                />
              )}
            </Grid>
          </Grid>
          {record=>(
            <MultipleDatesPicker
              open={dialogStates.openDatesSelector}
              minDate={moment(editRow.period, "YYYYMM").toDate()}
              submitButtonText="Confirm"
              selectedDates={userSelectedDates()}
              onCancel={() => setDialogStates({...dialogStates, openDatesSelector: false})}
              onSubmit={dates => {
                if (dates && Array.isArray(dates) && dates.length > 0) {
                  dates.sort((a, b) => a - b);
                  setEditRow({...editRow, userSelectedDates: dates, minRequiredDate: dates[0], maxRequiredDate:dates[dates.length - 1]});
                  setDialogStates({...dialogStates, openDatesSelector: false});
                } else {
                  setDialogStates({...dialogStates, openDatesSelector: false, fixedDates: false});
                  record["permitFixedDays"] = false;
                }
              }}
            />
          )}
        </PermitFormDialog>
        :
        <></>
      }
    </>
  )

  return {
    actionPermit,
    dialogBox
  }
}
